import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Breadcrumb({menuSet}) {
	const location = useLocation();
	const currentPath = location.pathname;
	const findMenuItem = (path, menu) => {
        for (let item of menu) {
            // if (item.link === path) {
            //     return { parent: null, item: item };
            // }
            if (item.subMenu) {
                for (let subItem of item.subMenu) {
                    if (subItem.link === path) {
                        return { parent: item, item: subItem };
                    }
                }
            }
        }
        return null;
    };
	const menuItem = findMenuItem(currentPath, menuSet);
	
	const bcChildrenBoxTogg = () => {
		const childrenBox = document.querySelector('.bc_children_box');
		if (childrenBox.classList.contains('open')) {
		    childrenBox.classList.remove('open');
		} else {
		    childrenBox.classList.add('open');
		}
	};

	return (
		<div className="breadcrumb_wrap">
            <ol>
                {menuItem && menuItem.parent && (
                    <>
                        <li className='bc_parents'>{menuItem.parent.name}</li>
                        <li className='bc_currents' onClick={bcChildrenBoxTogg}>{menuItem.item.name}</li>
                        <ul className='bc_children_box'>
							<li className='bc_children_close' onClick={bcChildrenBoxTogg}></li>
                            {menuItem.parent.subMenu.map(subItem => (
                                <li key={subItem.id} className={`bc_childrens ${currentPath === subItem.link ? 'active' : ''}`} >
                                    <Link className='bc_childrens_btn' to={subItem.link} onClick={bcChildrenBoxTogg}>{subItem.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </ol>
		</div>
	);
}

export default Breadcrumb;
